/**
 * Build Version Module
 * 
 * Provides build ID for cache-busting and version tracking.
 * The BUILD_ID is injected at build time via NEXT_PUBLIC_BUILD_ID environment variable.
 */

// Get build ID from environment variable (set at build time)
// Falls back to 'dev' for development environment
export const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID || 'dev';

/**
 * Get the current build ID
 * @returns The build ID string
 */
export function getBuildId(): string {
  return BUILD_ID;
}

/**
 * Check if running in development environment
 * @returns true if in development, false if in production
 */
export function isDevEnvironment(): boolean {
  return BUILD_ID === 'dev';
}

/**
 * Get build ID for display purposes (truncated for readability)
 * @returns Truncated build ID
 */
export function getDisplayBuildId(): string {
  if (isDevEnvironment()) {
    return 'Development';
  }
  // Show first 8 characters of build ID for production
  return BUILD_ID.substring(0, 8);
}
